/**
 * @generated SignedSource<<7228629c503bb315a211d63bf050a287>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EventPrimaryChargeType = "PER_PERSON" | "PER_SIGN_UP";
export type PrePaymentRequirement = "COLLECT_CARD_ON_FILE" | "FULL" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type PrimaryChargeSelectionStep_event$data = {
  readonly id: string;
  readonly prePaymentRequirement: PrePaymentRequirement | null | undefined;
  readonly primaryChargeType: EventPrimaryChargeType | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useGetAllPrimaryChargeSelectionOptions_event">;
  readonly " $fragmentType": "PrimaryChargeSelectionStep_event";
};
export type PrimaryChargeSelectionStep_event$key = {
  readonly " $data"?: PrimaryChargeSelectionStep_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"PrimaryChargeSelectionStep_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PrimaryChargeSelectionStep_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetAllPrimaryChargeSelectionOptions_event"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryChargeType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prePaymentRequirement",
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "b08598a9971f7421a8a1d20ad1ae5649";

export default node;
